export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-array/src/identity.js
// module id = 252
// module chunks = 0